module.exports = __webpack_public_path__ + "img/homepage.6458f951.png";